'use client';

import { cn } from '@core/utils';
import { Slot } from '@radix-ui/react-slot';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef, isValidElement } from 'react';

export interface SkeletonProps extends ComponentPropsWithoutRef<'span'> {
  /** true면 skeleton UI 표시, false면 children 표시 */
  loading?: boolean;
}

export const Skeleton = forwardRef<HTMLSpanElement, SkeletonProps>(
  ({ children, className, loading = true, ...props }, ref) => {
    if (!loading) return children;

    const Comp = isValidElement(children) ? Slot : 'span';

    return (
      <Comp
        ref={ref}
        aria-hidden
        className={cn('block animate-pulse bg-Gray-black/10', className)}
        tabIndex={-1}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);

Skeleton.displayName = 'Skeleton';
